import React from 'react';
import { ReactComponent as FigStar01Component } from './FigStar01.svg';

const FigStar01 = (props) => <FigStar01Component {...props} />;

export default FigStar01;
